export const EXTENSION_BLOCKLIST_FF =
	'confluence.frontend.extensions.server-render-top-x.blocklist';

export const TRACK_ON_TRANSITION = false;
